import { useQuery, useQueryClient } from '@tanstack/react-query';
import { scanApi } from '@/services/api';
import { useScan } from '@/contexts/ScanContext';

export function useDomainScan(domain: string) {
  const queryClient = useQueryClient();
  const { state } = useScan();

  // If the result is already in ScanContext (user navigated from search results),
  // seed the React Query cache with it so no HTTP call is needed.
  const contextResult = domain ? state.results.find(r => r.domain === domain) : undefined;

  const query = useQuery({
    queryKey: ['domain-scan', domain],
    queryFn: () => scanApi.scanSingle(domain),
    enabled: domain.length > 0,
    staleTime: 30 * 60_000,
    refetchOnWindowFocus: false,
    // Treat the in-memory context result as freshly fetched — avoids redundant HTTP call
    initialData: contextResult,
    initialDataUpdatedAt: contextResult ? Date.now() : undefined,
  });

  const forceRefresh = async () => {
    await queryClient.invalidateQueries({ queryKey: ['domain-scan', domain] });
    return queryClient.fetchQuery({
      queryKey: ['domain-scan', domain],
      queryFn: () => scanApi.scanSingle(domain, true),
      staleTime: 0,
    });
  };

  return { ...query, forceRefresh };
}
